const Logger = (props?: any[]) => {
  if (process.env.REACT_APP_ENV !== "dev") {
    return;
  }

  return props && console.log(...props);
};

export default Logger;
